import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartBar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.5 6.75H3.75a1 1 0 0 0-1 1v9.5a1 1 0 0 0 1 1H7.5m0-11.5v11.5m0-11.5v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8m0 0v7.5m0-7.5h3.75a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1H12.5m0 0h-5"
	})]
});
const ForwardRef = forwardRef(SvgChartBar);
export { ForwardRef as ReactComponent };
